import TutorialOverlay from "@/components/onboarding/TutorialOverlay";
import SideNav from "@/components/layout/SideNav";
import BottomNav from "@/components/layout/BottomNav";
import TopBar from "@/components/layout/TopBar";
import FlashStack from "@/components/layout/FlashStack";
import { Head, usePage } from "@inertiajs/react";
import type { PublicProps } from "@/types";

export default function Layout({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const { props } = usePage<PublicProps>();

  return (
    <>
      <Head>
        <title>{props.program.name}</title>
      </Head>

      <div
        className={`bg-bg bg-paper text-ink flex min-h-screen antialiased ${className ?? ""}`}
      >
        <SideNav />

        <div className="flex min-w-0 flex-1 flex-col">
          <TopBar />

          {/* pb-24 clears the mobile tab bar; the rail has no such overlap. */}
          <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6 pb-24 sm:px-6 lg:px-10 lg:py-10 lg:pb-10">
            {children}
          </main>
        </div>

        <BottomNav />
        <FlashStack />
        {/* The coach marks walk through Hackatime and shipping a project, so
            they only make sense while that program is on. Boba Bash uses
            WelcomeTour instead -- both read onboarding_completed, and running
            them together stacks two overlays on a first sign-in. */}
        {props.user && props.program?.projects_enabled && <TutorialOverlay />}
      </div>
    </>
  );
}
